import React, { useEffect, useState } from 'react';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import { GoogleOAuthProvider } from '@react-oauth/google';

import Card from '@material-ui/core/Card';
import CardMedia from '@material-ui/core/CardMedia';
import CardContent from '@material-ui/core/CardContent';

import { useDispatch, useSelector } from 'react-redux';
import { WATCH_USER } from '../../../redux/actionTypes';
import { Redirect } from 'react-router-dom';
import Typography from '@material-ui/core/Typography';
import AuthService from '../../../services/auth.service';
import GoogleLoginButton from './GoogleLoginButton';
import Divider from '@material-ui/core/Divider';
import { Alert, AlertTitle } from "@material-ui/lab";

const useStyles = makeStyles((theme) => ({
	form: {
		width: '100%', // Fix IE 11 issue.
		marginTop: theme.spacing(1),
	},
	submit: {
		margin: theme.spacing(3, 0, 2),
	},

	root: {
		maxWidth: 500,
		marginTop: theme.spacing(6),
	},
	media: {
		height: 0,
		paddingTop: '56.25%', // 16:9
		marginLeft: '4rem',
		marginRight: '4rem',
	},
	divider: {
		margin: theme.spacing(2, 0),
		position: 'relative',
	},
	dividerText: {
		position: 'absolute',
		top: '-10px',
		background: 'white',
		padding: '0 10px',
		left: '50%',
		transform: 'translateX(-50%)',
	},
}));

const Login = () => {
	const dispatch = useDispatch();
	const { fetching, user } = useSelector((content) => content.User);

	const classes = useStyles();

	const [valoresFormularios, setValoresFormularios] = useState({
		usuario: '',
		password: '',
	});
	const [showError, setShowError] = useState(false);
	const [googleLoginError, setGoogleLoginError] = useState(false);

	const handleChange = (e) => {
		setShowError(false);
		const { name, value } = e.target;
		const valoresFormulariosCopy = { ...valoresFormularios };
		valoresFormulariosCopy[name] = value;
		setValoresFormularios(valoresFormulariosCopy);
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		setShowError(false);
		const { usuario, password } = valoresFormularios;
		if (usuario !== '' && password !== '') {
			const success = await AuthService.login(usuario, password);
			if (success) {
				return dispatch({ type: WATCH_USER });
			}
		}
		setShowError(true);
	};

	const handleGoogleLoginError = () => {
		setGoogleLoginError(true);
	};

	useEffect(() => {
		dispatch({ type: WATCH_USER });
	}, [dispatch]);

	return (
		<>
			<Container component='main' maxWidth='xs'>
				<CssBaseline />

				<Card className={classes.root}>
					<CardMedia
						className={classes.media}
						image='/sabina.png'
						title='Sabina'
					/>
					<CardContent>
						<form className={classes.form} noValidate>
							<TextField
								className={classes.textfield}
								variant='outlined'
								margin='normal'
								required
								fullWidth
								id='usuario'
								label='Usuario'
								name='usuario'
								autoComplete='usuario'
								autoFocus
								onChange={handleChange}
							/>
							<TextField
								className={classes.textfield}
								variant='outlined'
								margin='normal'
								required
								fullWidth
								name='password'
								label='Contraseña'
								type='password'
								id='password'
								autoComplete='current-password'
								onChange={handleChange}
							/>
							<Button
								type='submit'
								fullWidth
								variant='contained'
								color='primary'
								className={classes.submit}
								onClick={handleSubmit}>
								Acceder
							</Button>

							{showError && (
								<Alert severity='error' >
									<AlertTitle>Acceso denegado</AlertTitle>
									Usuario o contraseña incorrecto.
								</Alert>
							)}
							
							<div className={classes.divider}>
								<Divider />
								<Typography className={classes.dividerText} variant="body2" color="textSecondary">
									o
								</Typography>
							</div>
							<GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
								<GoogleLoginButton onLoginError={handleGoogleLoginError} />
							</GoogleOAuthProvider>
							{googleLoginError && (
								<Alert severity='error' style={{ marginTop: '1rem' }}>
									<AlertTitle>Acceso denegado</AlertTitle>
									Solicite acceso al administrador del sistema.
								</Alert>
							)}
						</form>
					</CardContent>
				</Card>
			</Container>
			{!fetching && user && <Redirect to={`${process.env.PUBLIC_URL}/`} />}
		</>
	);
};

export default Login;
